var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.indexItem + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.sshKey.name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.sshKey.fingerprint))]),_vm._v(" "),_c('td',{staticStyle:{"word-break":"break-word"}},[_vm._v(_vm._s(_vm.sshKey.public_key))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42098cf2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/digital-ocean/ssh-keys/DigitalOceanItemSshKey.vue
// module id = null
// module chunks = 